<template>
  <div id="footer" class="container-fluid">
    <p class="address_tel_fax">
      <span>地址：北京大兴西红门嘉悦广场8号楼1605</span>
    </p>
    <div class="email_wx">
      <span>邮箱：hr@huizhicreate.com</span>
      <div style="padding: 10px;">
        <a href="https://beian.miit.gov.cn" target="_blank">京ICP备18048406号-1</a>
      </div>
    </div>
    <p class="copy">Copyright &copy; 2020 - 2021 北京汇智共创科技发展有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #ffffff;
  background: #191970;
  overflow: hidden;
  text-align: center;
}

.logo, .logo > img {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #778899;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #778899;
  font-size: 14px;
}

.copy {
  /*color: #d3d3d3;*/
  color: #778899;
  font-size: 14px;
  margin: 20px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 20px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue